<div class="entertainment-overlay" *ngIf="visible" (click)="close()">
  <div class="entertainment-form" (click)="$event.stopPropagation()">
    <div class="form-header">
      <h2>{{formName}}</h2>
      <button class="close-btn" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

      <div class="form-field" *ngFor="let field of customFields, let i = index">
        <div class="form-field" *ngIf="field.is_active && (field.field_type != 'dropdown' || (field.field_type == 'dropdown' && field.options))">
          <div class="field-label">{{ field.field_name }}</div>
            <div class="field-input" *ngIf="field.field_type == 'text'">
              <input id="{{'customField_' + i }}"  [ngModelOptions]="{standalone: true}"  [(ngModel)]="field.field_value" class="frm-input"
              type="text" [placeholder]="!isEditable ? '': 'Enter Details'" [disabled]="!isEditable"
              [ngClass]="isEditable ? 'frm-input-active' : ''">
            </div>
            <div class="field-input" *ngIf="field.field_type == 'date'">
              <mat-form-field *ngIf="isEditable" appearance="none" class="new-frm-input">
                <input matInput [matDatepicker]="picker" [disabled]="!isEditable"
                       [(ngModel)]="field.field_value" (click)="picker.open()"
                       [ngClass]="isEditable ? 'frm-input-active' : ''"
                       [placeholder]="!isEditable ? '': 'Select Date'"
                       [ngModelOptions]="{standalone: true}">
                <button class="cal-clear-btn" mat-button *ngIf="field.field_value" matSuffix mat-icon-button aria-label="Clear" (click)="field.field_value=''">
                  <mat-icon>x</mat-icon>
                </button>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="field-input" *ngIf="field.field_type == 'dropdown'">
              <ng-select [(ngModel)]="field.field_value" [items]="field.optionsArr" 
                                [placeholder]="!isEditable ? '': 'Select Value'"
                                [readonly]="!isEditable"
                                class="frm-ng-select" [ngModelOptions]="{standalone: true}">
                      </ng-select>
            </div>
            <div class="field-input" *ngIf="field.field_type == 'number'">
              <input type="text" [(ngModel)]="field.field_value" [disabled]="!isEditable"
              class="frm-input" (keypress)="numberOnly($event)" [ngModelOptions]="{standalone: true}"
              [placeholder]="!isEditable ? '': 'Enter Value'"/>
            </div>
        </div>
      </div>

      <div class="form-header" *ngIf="!isEditable">
        <h5>Completed By: {{assignToUserName}}</h5>
      </div>

      <div class="form-actions" *ngIf="isEditable">
        <button type="button" class="btn-secondary" (click)="close()">Cancel</button>
        <button type="button" class="btn-primary" (click)="onSubmit()">Save Details</button>
      </div>
  </div>
</div>
